import { useState } from "react";

import {
  makeGetApiCall,
  makePostApiCall,
  makePutApiCall,
} from "../../../shared/makeApiCall";
import DeleteConfirmationForm from "../../../components/forms/DeleteConfirmationForm";
import {
  generateUniqueNumber,
  updateObjectInArray,
} from "../../../shared/utility";
import ModelErrorComponent from "../../../components/modals/ModelErrorComponent";
import ProductOdourForm from "../../../components/forms/setup/productOdours/ProductOdourForm";
import { SnackbarData, SnackbarType } from "../../../components/Snackbar";

export function ProductOdoursViewModel(addSnackbar, logout) {
  const [loading, setLoading] = useState(false);
  const [productOdours, setProductOdours] = useState({
    data: [],
  });
  const [slideOver, setSlideOver] = useState({
    childComponent: null,
    open: false,
  });
  const [emptyModal, setEmptyModelOpen] = useState({
    open: false,
    childComponent: null,
  });

  const showErrorModal = (title, subtitle) => {
    setEmptyModelOpen({
      childComponent: (
        <ModelErrorComponent
          setOpen={setEmptyModelOpen}
          subtitle={subtitle}
          title={title}
        />
      ),
      open: true,
    });
  };

  const getProductOdours = async function (search, page) {
    setLoading(true);

    let callResult = await makeGetApiCall(
      `productOdours?page=${page}&search=${search}`
    );
    setLoading(false);
    if (callResult.success) {
      setProductOdours(callResult.data);
    } else {
      if (callResult.errorStatus === 401) {
        logout();
      }
      showErrorModal(callResult.data.message);
    }
  };

  const createOdour = async function (values) {
    const payload = { ...values };
    let callResult = await makePostApiCall("productOdours/create", payload);

    if (callResult.success) {
      addSnackbar(
        new SnackbarData(
          generateUniqueNumber(),
          callResult.data.message,
          SnackbarType.Success
        )
      );
      setSlideOver({
        childComponent: null,
        open: false,
      });
      setTimeout(function () {
        getProductOdours("", 1);
      }, 1000);
    } else {
      if (callResult.errorStatus === 401) {
        logout();
      }
    }
  };

  const updateOdour = async function (values, index) {
    let callResult = await makePutApiCall(`productOdours/${values.id}`, values);

    if (callResult.success) {
      addSnackbar(
        new SnackbarData(
          generateUniqueNumber(),
          callResult.data.message,
          SnackbarType.Success
        )
      );
      setSlideOver({
        childComponent: null,
        open: false,
      });

      const currentItems = [...productOdours.data];
      var payload = {
        index: index,
        item: callResult.data.item,
      };
      const newItems = updateObjectInArray(currentItems, payload);
      setProductOdours({ ...productOdours, data: newItems });
    } else {
      if (callResult.errorStatus === 401) {
        logout();
      }
    }
  };

  const openAddNewSlideOver = (isEdit, odour, index) => {
    setSlideOver({
      childComponent: (
        <ProductOdourForm
          odour={odour}
          isEdit={isEdit}
          setOpen={setSlideOver}
          actionCall={(payload) =>
            isEdit ? updateOdour(payload, index) : createOdour(payload)
          }
          title={isEdit ? `Update ${odour.name}` : "Add new odour"}
          inProgress={false}
        />
      ),
      open: true,
    });
  };

  const deleteOdour = async function (id, index) {
    setLoading(true);

    let callResult = await makePostApiCall(`deleteProductOdour/${id}`);
    setLoading(false);
    if (callResult.success) {
      setEmptyModelOpen({
        open: false,
        childComponent: null,
      });

      const newItems = productOdours.data.filter((item) => item.id !== id);
      setProductOdours({ ...productOdours, data: newItems });

      addSnackbar(
        new SnackbarData(
          generateUniqueNumber(),
          callResult.data.message,
          SnackbarType.Success
        )
      );
    } else {
      if (callResult.errorStatus === 401) {
        logout();
      }
    }
  };

  const askDelete = function (odour, index) {
    setEmptyModelOpen({
      childComponent: (
        <DeleteConfirmationForm
          buttonMessage="Delete"
          confirmAction={() => deleteOdour(odour.id, index)}
          message={`Are you sure you want to delete ${odour.name}?`}
          setOpen={setEmptyModelOpen}
          hideReason={true}
        />
      ),
      open: true,
    });
  };

  return {
    openAddNewSlideOver,
    getProductOdours,
    loading,
    productOdours,
    setSlideOver,
    slideOver,
    setEmptyModelOpen,
    emptyModal,
    askDelete,
  };
}
